export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/2724cb704a1ac3dfbb01f8a7ab88df70.png"
              alt="InstaVisible"
              className="h-10 w-auto mb-6"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              Transform your business communication with AI voice agents that work 24/7 to drive results.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('video-demo')}
                  className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Demo
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Pricing
                </button>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Support</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <a
                  href="mailto:support@instavisible.com"
                  className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  support@instavisible.com
                </a>
              </li>
              <li>
                <a
                  href="https://calendly.com/instavisible/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Book a Demo
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Stay Updated</h3>
            <p className="text-gray-400 mb-4">
              Subscribe to our newsletter for the latest updates and insights.
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 bg-white/10 border border-white/20 rounded-l-lg focus:outline-none focus:border-orange-500 text-sm"
              />
              <button className="px-4 py-2 bg-orange-500 hover:bg-orange-600 rounded-r-lg transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-send-plane-fill"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-12 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} InstaVisible. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
